module.exports = __webpack_public_path__ + "static/img/handshake.7cf2b040.png";